var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityLevelAccessAndAutomaticDoorsOrNoDoors = function SvgAccessibilityLevelAccessAndAutomaticDoorsOrNoDoors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M29.053 25.549H.947"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 13.4,
    cy: 6.436,
    r: 2.042
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M14.174 10.24a2.7 2.7 0 0 1-2.33-.326m-.835 6.236a4.823 4.823 0 1 1-2.06 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M11.834 9.914a9.96 9.96 0 0 0-2.58 3.559c-.638 1.47-.588 2.939.113 4.382q.316.651.76 1.223c.252.32.43.65.818.818.641.278 1.233-.32 1.151-.925-.074-.548-.494-.977-.76-1.44a5.1 5.1 0 0 1-.609-1.517c-.14-.7-.023-1.422.486-1.949l.555 1.809m5.288 2.764 1.243-.097c.053.113 1.653 3.757 1.854 4.202.153.339.297.748.627.953.18.108.394.146.6.105a.963.963 0 0 0 .713-1.244l-2.005-6.15a.45.45 0 0 0-.391-.31c-1.277-.121-2.455-.239-3.74-.354l-1.783-5.504"
  }))));
};
export default SvgAccessibilityLevelAccessAndAutomaticDoorsOrNoDoors;